import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", fillRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, clipRule: "evenodd", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "m12.25 14.4 4.36-4.37-.53-.53-4.1 4.1-4.06-4.07-.53.53 4.33 4.33a.37.37 0 0 0 .53 0Z" }));
const ForwardRef = forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
